export { useWidgetSmartChoice } from './useWidgetSmartChoice';
